import { servicesList } from "constants/services";

const initialState = {
    servicesList: {},
};

const service = (state = initialState, action) => {
    switch (action.type) {
        case servicesList:
            return { ...state, servicesList: action.payload };
        default:
            return state;
    }
};

export default service;